function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { LOAD_CHILDREN_OPTIONS, Treeselect } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import ElSelectTree from 'el-select-tree';
import { getCon, getContinentList, getChildCountry, getCountryCodeByCity, getCityCodeName, getUnderCountry, getUnderCity, getProvinceCity } from '@/utils/country';
import { isNumber } from '@/utils/util';
import { customRegion_queryPage, saveCustomRegion, deleteCustomRegion } from '@/api/baseDataManage';
import { continentList, getCompanyList } from '@/api/baseDate';
export default {
  name: 'customRegion',
  components: {
    Treeselect: Treeselect,
    ElSelectTree: ElSelectTree
  },
  data: function data() {
    return {
      company: '',
      //保险公司
      companyList: [],
      //获取保险公司列表并匹配
      // 查询条件
      form: {
        insuranceCompanyCode: '',
        pageNo: 1,
        pageSize: 10,
        codeCname: ''
      },
      total: 0,
      //数据条数
      // 列表数据
      tableData: [],
      loading: false,
      screenLoading: null,
      newumarBtn: false,
      new_edit: false,
      editData: {},
      coStartCityCodeList: [],
      //编辑初始化的数据
      coStartCityCodeListNew: [],
      //新增初始化的数据
      sortValueBy: 'LEVEL',
      options: [],
      continentList: [],
      // 洲
      countryList: [],
      // 国家
      cityList: [],
      // 城市
      markForm: {
        id: '',
        //不填
        typeName: '自定义地区',
        //默认
        codeType: 'area',
        //默认
        codeCode: '',
        //不填
        codeCname: '',
        //需要录入的
        codeEname: '',
        //需要录入的
        platformCodeCode: '',
        //需要录入的
        platformCodeName: '',
        //需要录入的
        insuranceCompanyCode: '',
        //默认当前登录用户的保险公司
        insuranceCompanyName: '',
        //默认当前登录用户的保险公司
        validStatus: '' //有效无效--展示

      },
      markForm_new: {
        id: '',
        //不填
        typeName: '自定义地区',
        //默认
        codeType: 'area',
        //默认
        codeCode: '',
        //不填
        codeCname: '',
        //需要录入的
        codeEname: '',
        //需要录入的
        platformCodeCode: '',
        //需要录入的
        platformCodeName: '',
        //需要录入的
        insuranceCompanyCode: '',
        //默认当前登录用户的保险公司
        insuranceCompanyName: '',
        //默认当前登录用户的保险公司
        validStatus: '1' //有效无效--展示

      },
      customRegion_rule: {
        codeCname: [{
          required: true,
          message: '请输入自定义地区名称',
          trigger: 'blur'
        }],
        platformCodeCode: [{
          required: true,
          message: '请输入关联国家或城市',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    getCompanyList().then(function (res) {
      _this.companyList = Object.assign([], res); // this.company = this.form.insuranceCompanyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode

      _this.company = _this.form.insuranceCompanyCode = JSON.parse(sessionStorage.getItem('newinsurancecompanyCode'));

      _this.getData();
    });
    this.continentList = getCon();
    var opsd = this.options || [];

    if (opsd.length < 1) {
      this.initRegion('');
    }
  },
  methods: {
    //   查询
    submitForm: function submitForm(formName) {
      this.form.pageNo = 1;
      this.getData();
    },
    getData: function getData() {
      var _this2 = this;

      this.loading = true;
      customRegion_queryPage(_objectSpread({}, this.form)).then(function (res) {
        _this2.loading = false;
        _this2.total = res.totalCount;
        _this2.tableData = Object.assign([], res.content);
      });
    },
    //   重置查询条件
    resetForm: function resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.form.codeCname = '';
      this.getData();
    },
    // 分页方法
    handleSizeChange: function handleSizeChange(val) {
      this.form.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getData();
    },
    //编辑/新增保存
    editSave: function editSave(formName, type) {
      var _this3 = this;

      var data = type == 'edit' ? this.markForm : this.markForm_new;

      if (type == 'edit') {
        this.markForm.type = '1';
        console.log('1-----------', this.coStartCityCodeList);

        if (this.coStartCityCodeList && this.coStartCityCodeList.length > 0) {
          // 含启运地城市
          this.markForm.platformCodeCode = this.coStartCityCodeList.join(',');
        } else {
          this.markForm.platformCodeCode = '';
          this.$message({
            message: '请选择关联国家或城市',
            type: 'warning'
          });
          return;
        }

        console.log('2-----------', this.markForm.platformCodeCode);
      } else {
        this.markForm_new.type = '0';
        console.log('3-----------', this.coStartCityCodeListNew);

        if (this.coStartCityCodeListNew && this.coStartCityCodeListNew.length > 0) {
          // 含启运地城市
          this.markForm_new.platformCodeCode = this.coStartCityCodeListNew.join(',');
        } else {
          this.markForm_new.platformCodeCode = '';
          this.$message({
            message: '请选择关联国家或城市',
            type: 'warning'
          });
          return;
        }

        console.log('4-----------', this.markForm_new.platformCodeCode);
      }

      this.$refs[formName].validate(function (valid) {
        console.log(valid, 'valid');

        if (valid) {
          _this3.new_edit = _this3.newumarBtn = false;

          _this3.openFullScreen();

          saveCustomRegion(data).then(function (res) {
            // console.log(res)
            if (res.resultCode == '0000') {
              _this3.$message({
                message: '保存成功',
                type: 'success'
              });

              for (var key in _this3.markForm_new) {
                _this3.markForm_new[key] = '';
              }

              _this3.getData();
            } else {
              _this3.$message({
                message: res.resultMsg,
                type: 'warning'
              });
            }

            _this3.screenLoading.close();

            _this3.markForm_new = {
              id: '',
              //不填
              typeName: '自定义地区',
              //默认
              codeType: 'area',
              //默认
              codeCode: '',
              //不填
              codeCname: '',
              //需要录入的
              codeEname: '',
              //需要录入的
              platformCodeCode: '',
              //需要录入的
              platformCodeName: '',
              //需要录入的
              insuranceCompanyCode: '',
              //默认当前登录用户的保险公司
              insuranceCompanyName: '',
              //默认当前登录用户的保险公司
              validStatus: '1' //有效无效--展示

            };
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 编辑
    edit: function edit(data) {
      console.log('编辑初始化,', data);
      this.editData = data;
      this.new_edit = true;

      for (var key in this.markForm) {
        this.markForm[key] = data[key];
      }

      if (data.platformCodeCode) {
        // 含启运地城市
        this.coStartCityCodeList = data.platformCodeCode.split(',');
      }

      console.log('编辑初始化,', this.coStartCityCodeList);
    },
    // 删除
    dele: function dele(data) {
      var _this4 = this;

      console.log(data);
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteCustomRegion({
          id: data.id
        }).then(function (res) {
          // console.log(res)
          if (res.resultCode == '0000') {
            _this4.$message({
              type: 'success',
              message: '删除成功!'
            });

            _this4.getData();
          } else {
            _this4.$message({
              type: 'warning',
              message: res.resultMsg
            });
          }
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 取消
    selectcancel: function selectcancel(formname, type) {
      var _this5 = this;

      if (type == 'new') {
        this.newumarBtn = false;
      } else {
        this.new_edit = false;
      }

      this.$nextTick(function () {
        _this5.$refs[formname].clearValidate();
      });
    },
    openFullScreen: function openFullScreen() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    initRegion: function initRegion(cityStr) {
      var _this6 = this;

      this.options = [];
      getCon().forEach(function (ite) {
        var children = getChildCountry(ite.codeCode);
        var counChild = []; // 国家

        var newCount = []; //选中国家

        if (cityStr != '' && cityStr != null && cityStr != undefined) {
          var reg = new RegExp("null,", "g");
          var cStrs = cityStr.replace(reg, "");
          cStrs = cStrs.substring(0, cStrs.length - 1);
          var citycod = cStrs.split(',');
          var citycode = Array.from(new Set(citycod)); //提取

          if (citycode.length > 0) {
            citycode.forEach(function (itd) {
              if (itd.length >= 6) {
                var cots = getCountryCodeByCity(itd);
                newCount.push(cots);
              } else if (isNumber(itd)) {
                //中国大陆下面所以数据加载进入
                newCount.push("CHN");
              }
            });
          }
        }

        var _loop = function _loop(j) {
          // 获取之前选中的城市代码
          var cityChild = [];

          if (newCount.length > 0) {
            var newCo2 = Array.from(new Set(newCount));
            newCo2.forEach(function (itdds) {
              if (children[j].codeCode == itdds) {
                var _counts = getUnderCity(itdds);

                if (itdds == "CHN") {
                  _counts.forEach(function (ites) {
                    var cncity = [];
                    var cncityList = getProvinceCity(ites.codeCode);
                    cncityList.forEach(function (itcnty) {
                      var cntysds = {
                        'id': itcnty.codeCode,
                        'label': itcnty.codeCname,
                        'level': '4'
                      };
                      cncity.push(cntysds);
                    });
                    var city = {
                      'id': ites.codeCode,
                      'label': ites.codeCname,
                      'level': '3',
                      'children': cncity
                    };
                    cityChild.push(city);
                  });
                } else {
                  _counts.forEach(function (ites) {
                    var city = {
                      'id': ites.codeCode,
                      'label': ites.codeCname,
                      'level': '3'
                    };
                    cityChild.push(city);
                  });
                }
              }
            });
          }

          if (cityChild.length == 0) {
            cityChild = null;
          }

          var counts = {
            'id': children[j].codeCode,
            'label': children[j].codeCname,
            'level': '2',
            'children': cityChild
          };
          counChild.push(counts);
        };

        for (var j = 0; j < children.length; j++) {
          _loop(j);
        }

        if (counChild.length == 0) {
          counChild = null;
        }

        var cons = {
          'id': ite.codeCode,
          'label': ite.codeCname,
          'level': '1',
          'children': counChild
        };

        _this6.options.push(cons);
      });
    },
    //加载城市方法
    loadOptions: function loadOptions(_ref) {
      var action = _ref.action,
          parentNode = _ref.parentNode,
          callback = _ref.callback;

      if (action === LOAD_CHILDREN_OPTIONS) {
        switch (parentNode.level) {
          // 判断选择级别
          case '2':
            var city = getUnderCity(parentNode.id);
            var cityChild = [];
            city.forEach(function (item) {
              var chids;

              if (item.children) {
                chids = {
                  'id': item.codeCode,
                  'label': item.codeCname,
                  'level': '3',
                  'children': null
                };
              } else {
                chids = {
                  'id': item.codeCode,
                  'label': item.codeCname,
                  'level': '3'
                };
              }

              cityChild.push(chids);
            });
            parentNode.children = cityChild; // 增加子节点

            callback();
            break;

          case '3':
            var citycn = getProvinceCity(parentNode.id);
            var cityCldd = [];
            citycn.forEach(function (item) {
              var chids = {
                'id': item.codeCode,
                'label': item.codeCname,
                'level': '4'
              };
              cityCldd.push(chids);
            });
            parentNode.children = cityCldd; // 增加子节点

            callback();
            break;
        }
      }
    }
  }
};